import styled, { css } from 'styled-components';

interface ContainerProps {
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: #fff;
  border-radius: 10px;
  border: 2px solid #fff;
  padding: 16px;
  width: 100%;
  color: #333;

  display: flex;
  align-items: center;
  position: relative; // Para posicionar o label ou span de erro
  gap: 4px;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  label {
    display: block;
    margin-bottom: 8px;
    margin-right: 8px;
    color: #333; // Cor para o label
  }

  input[type='file'] {
    flex: 1;
    background: transparent;
    border: 0;
    color: #333;

    &::file-selector-button {
      background: #ff9000;
      color: #3e3e3e;
      border: 0;
      padding: 8px 16px;
      border-radius: 5px;
      cursor: pointer;
      margin-right: 16px;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  span {
    color: #c53030;
    margin-top: 4px;
    font-size: 14px;
    position: absolute;
    bottom: -20px; // Posição do erro
    left: 0;
  }
`;
